export default "__VITE_ASSET__71a29914__"